module.exports = global["jQuery"] = require("-!/home/deployer/validacion_facturas/tmp/build-17049006067337/node_modules/expose-loader/index.js?$!./jquery.js");